import { useTranslation as useI18nTranslation } from 'react-i18next';

export const useTranslation = (
  ns?: string | string[],
  options?: Parameters<typeof useI18nTranslation>[1]
) => {
  return useI18nTranslation(ns as any, options as any);
};

